// extracted by mini-css-extract-plugin
export var chatHtmlText = "_s8-2";
export var chatLink = "_s8-0";
export var chatText = "_s8-1";